'use strict';

import React from 'react';
import ReactDOM from 'react-dom';
import CodeMirror from 'react-codemirror';
import { uuid } from 'rt-sd-common/sgiCommon/sgiCommon'

require('codemirror/lib/codemirror.css');
require('codemirror/addon/fold/foldgutter.css');

require('codemirror/mode/javascript/javascript');
require('codemirror/addon/fold/foldcode.js');
require('codemirror/addon/fold/foldgutter.js');
require('codemirror/addon/fold/brace-fold.js');
require('codemirror/addon/fold/comment-fold.js');
require('codemirror/addon/edit/matchbrackets.js');
require('codemirror/addon/edit/closebrackets.js');

require('codemirror/addon/hint/show-hint.css');
require('codemirror/addon/hint/show-hint.js');
require('codemirror/addon/hint/javascript-hint.js');

require('codemirror/addon/lint/lint.js');
require('codemirror/addon/lint/lint.css');
require('codemirror/mode/css/css.js');
require('codemirror/addon/lint/javascript-lint.js');

require('codemirror/addon/scroll/annotatescrollbar.js');
require('codemirror/addon/search/matchesonscrollbar.js');
require('codemirror/addon/search/matchesonscrollbar.css');
require('codemirror/addon/search/searchcursor.js');
require('codemirror/addon/search/match-highlighter.js');

const codemirror_js_tags = [];

const codemirror_options = {
    lineNumbers: true,
    mode: 'javascript',
    lineWrapping: true, //代码折叠
    foldGutter: true,
    // showHint: true,
    // highlightSelectionMatches: true,
    highlightSelectionMatches: { showToken: /\w/, annotateScrollbar: true },
    extraKeys: { "Ctrl-/": "autocomplete" },
    hintOptions: { schemaInfo: codemirror_js_tags },
    lint: true,
    gutters: ["CodeMirror-linenumbers", "CodeMirror-foldgutter",
        'CodeMirror.hint.javascript', 'CodeMirror.hint.coffeescript', 'CodeMirror-lint-markers'],
    matchBrackets: true,	//括号匹配
    autoCloseBrackets: true //关闭
};

let getContainerBackgroundColor = function (isActive, canDrop, hover) {
    let backgroundColor = 'rgb(205,221,238)'
    if (isActive) {
        backgroundColor = 'rgb(88,158,148)'
    } else if (canDrop) {
        backgroundColor = 'rgb(197,212,194)'
    } else if (hover) {
        // backgroundColor = '#49a9ee1c'
        backgroundColor = 'rgb(143,182,211)'
    }
    return backgroundColor;
}

let getBackgroundColor = function (isActive, canDrop, hover) {
    let backgroundColor = 'rgb(205,221,238)'
    if (isActive) {
        backgroundColor = 'rgb(88,158,148)'
    } else if (canDrop) {
        backgroundColor = 'rgb(197,212,194)'
    } else if (hover) {
        // backgroundColor = '#49a9ee1c'
        backgroundColor = 'rgb(143,182,211)'
    }
    return backgroundColor;
}

let getCodeMirror = function (value, onChange, key, height) {
    return <CodeMirror key={key} options={codemirror_options} autoFocus={true}
        value={value} style={{ height: height || '300px' }}
        onChange={onChange} />
}



let getShowTypeDivCss = {
    position: 'absolute', top: 0, right: 0, 'font-size': '8px', backgroundColor: 'red',
    mixWidth: '70px', height: '20px', 'z-index': 100,
    padding: '1px 3px 1px 3px', color: 'rgb(255, 255, 255)',
    lineHeight: "20px"
}

export {
    codemirror_options, getCodeMirror, getBackgroundColor, getShowTypeDivCss, getContainerBackgroundColor
};


// WEBPACK FOOTER //
// ./~/rt-sd-dnd/sgiDndDev/Dnd_SgiAllEditorCommon.js